import actionConstants from '../constants/';

const getReportFeatures = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getDownloadReport = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data:{},
  errorMessage: '',
};

const getReportCategoryDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getUserEmails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const generateInstantReport = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};
const allReportsList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};
const getMasterList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};


const saveCustomReport = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const createScheduledReport = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const pauseScheduledReport = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const resumeScheduledReport = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const scheduleReportsList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};
const updateScheduledReport = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const initialState = {
  updateScheduledReport: { ...updateScheduledReport },
  generateInstantReport: { ...generateInstantReport },
  getReportFeatures: { ...getReportFeatures },
  getUserEmails: { ...getUserEmails },
  allReportsList: {...allReportsList},
  getMasterList: { ...getMasterList },
  getReportCategoryDetails: {...getReportCategoryDetails},
  getDownloadReport: {...getDownloadReport},
  saveCustomReport: { ...saveCustomReport },
  createScheduledReport: { ...createScheduledReport },
  pauseScheduledReport: { ...pauseScheduledReport },
  resumeScheduledReport: { ...resumeScheduledReport },
  scheduleReportsList: { ...scheduleReportsList },
  deleteScheduledReport: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    errorCode: 0,
    data: {},
    errorMessage: '',
  },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET_REPORT_FEATURES
    case actionConstants.GET_REPORT_FEATURES_REQUEST:
      return {
        ...state,
        getReportFeatures: {
          ...state.getReportFeatures,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_REPORT_FEATURES_SUCCESS:
      return {
        ...state,
        getReportFeatures: {
          ...state.getReportFeatures,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_REPORT_FEATURES_FAILURE:
      return {
        ...state,
        getReportFeatures: {
          ...state.getReportFeatures,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_REPORT_FEATURES_CLEAR:
      return {
        ...state,
        getReportFeatures: {
          ...initialState.getReportFeatures,
          data: {},
        },
      };

      // GET DOWNLOAD REPORT

      case actionConstants.GET_DOWNLOAD_REPORT_REQUEST:
  return {
    ...state,
    getDownloadReport: {
      ...state.getDownloadReport,
      isLoading: true,
      isSuccess: false,
      isFailure: false,
      errorCode: 0,
    },
  };

case actionConstants.GET_DOWNLOAD_REPORT_SUCCESS:
  return {
    ...state,
    getDownloadReport: {
      ...state.getDownloadReport,
      isLoading: false,
      isSuccess: true,
      isFailure: false,
      data: action.payload.body, 
    },
  };

case actionConstants.GET_DOWNLOAD_REPORT_FAILURE:
  return {
    ...state,
    getDownloadReport: {
      ...state.getDownloadReport,
      isLoading: false,
      isSuccess: false,
      isFailure: true,
      errorCode: action?.payload?.errorCode, 
    },
  };

case actionConstants.GET_DOWNLOAD_REPORT_CLEAR:
  return {
    ...state,
    getDownloadReport: {
      ...initialState.getDownloadReport,
      data: {},
    },
  };

      // GET MASTER STATUS LIST
      case actionConstants.GET_MASTER_LIST_REQUEST:
        return {
          ...state,
          getMasterList: {
            ...state.getMasterList,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            errorCode: 0,
          },
        };
  
      case actionConstants.GET_MASTER_LIST_SUCCESS:
        return {
          ...state,
          getMasterList: {
            ...state.getMasterList,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
          },
        };
  
      case actionConstants.GET_MASTER_LIST_FAILURE:
        return {
          ...state,
          getMasterList: {
            ...state.getMasterList,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
          },
        };
  
      case actionConstants.GET_MASTER_LIST_CLEAR:
        return {
          ...state,
          getMasterList: {
            ...initialState.getMasterList,
            data: {},
          },
        };

    // GET_REPORT_USER_EMAILS
    case actionConstants.GET_REPORT_USER_EMAILS_REQUEST:
      return {
        ...state,
        getUserEmails: {
          ...state.getUserEmails,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_REPORT_USER_EMAILS_SUCCESS:
      return {
        ...state,
        getUserEmails: {
          ...state.getUserEmails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_REPORT_USER_EMAILS_FAILURE:
      return {
        ...state,
        getUserEmails: {
          ...state.getUserEmails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_REPORT_USER_EMAILS_CLEAR:
      return {
        ...state,
        getUserEmails: {
          ...initialState.getUserEmails,
          data: {},
        },
      };


   // GET_REPORT_CATEGORY_DETAILS
    case actionConstants.GET_REPORT_CATEGORY_DETAILS_REQUEST:
      return {
        ...state,
        getReportCategoryDetails: {
          ...state.getReportCategoryDetails,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_REPORT_CATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        getReportCategoryDetails: {
          ...state.getReportCategoryDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_REPORT_CATEGORY_DETAILS_FAILURE:
      return {
        ...state,
        getReportCategoryDetails: {
          ...state.getReportCategoryDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_REPORT_CATEGORY_DETAILS_CLEAR:
      return {
        ...state,
        getReportCategoryDetails: {
          ...initialState.getReportCategoryDetails,
          data: {},
        },
      };

    // GENERATE_INSTANT_REPORTS
    case actionConstants.GENERATE_INSTANT_REPORTS_REQUEST:
      return {
        ...state,
        generateInstantReport: {
          ...state.generateInstantReport,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GENERATE_INSTANT_REPORTS_SUCCESS:
      return {
        ...state,
        generateInstantReport: {
          ...state.generateInstantReport,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GENERATE_INSTANT_REPORTS_FAILURE:
      return {
        ...state,
        generateInstantReport: {
          ...state.generateInstantReport,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.error_code,
          errorMessage: action.payload.body.error_message,
        },
      };

    case actionConstants.GENERATE_INSTANT_REPORTS_CLEAR:
      return {
        ...state,
        generateInstantReport: {
          ...generateInstantReport,
        },
      };
      case actionConstants.GET_ALL_REPORT_LIST_REQUEST:
            return {
              ...state,
              allReportsList : {
                ...state.allReportsList ,
                isLoading: true,
                isSuccess: false,
                isFailure: false,
                errorCode: 0,
              },
            };
          case actionConstants.GET_ALL_REPORT_LIST_SUCCESS:
            return {
              ...state,
              allReportsList : {
                ...state.allReportsList ,
                isLoading: false,
                isSuccess: true,
                isFailure: false,
                data: action.payload.body,
              },
            };
          case actionConstants.GET_ALL_REPORT_LIST_FAILURE:
            return {
              ...state,
              allReportsList: {
                ...state.allReportsList,
                isLoading: false,
                isSuccess: false,
                isFailure: true,
                data: [],
                errorCode: 0
              },
            };
          case actionConstants.GET_ALL_REPORT_LIST_CLEAR:
            return {
              ...state,
              allReportsList : {
                isLoading: false,
                isSuccess: false,
                isFailure: false,
                allMerchantsList: {
                  ...initialState.allReportsList,
                  data: {},
                },
              },
            };

    // GET_SCHEDULE_REPORT_LIST
    case actionConstants.GET_SCHEDULE_REPORT_LIST_REQUEST:
      return {
        ...state,
        scheduleReportsList: {
          ...state.scheduleReportsList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_SCHEDULE_REPORT_LIST_SUCCESS:
      return {
        ...state,
        scheduleReportsList: {
          ...state.scheduleReportsList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_SCHEDULE_REPORT_LIST_FAILURE:
      return {
        ...state,
        scheduleReportsList: {
          ...state.scheduleReportsList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: [],
          errorCode: action.payload.body?.error_code || 0,
          errorMessage: action.payload.body?.error_message || 'Failed to fetch schedule reports',
        },
      };
    case actionConstants.GET_SCHEDULE_REPORT_LIST_CLEAR:
      return {
        ...state,
        scheduleReportsList: { ...scheduleReportsList },
      };


    // SAVE_CUSTOM_REPORT
    case actionConstants.SAVE_CUSTOM_REPORT_REQUEST:
      return {
        ...state,
        saveCustomReport: {
          ...state.saveCustomReport,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };
    case actionConstants.SAVE_CUSTOM_REPORT_SUCCESS:
      return {
        ...state,
        saveCustomReport: {
          ...state.saveCustomReport,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorMessage: '',
        },
      };
    case actionConstants.SAVE_CUSTOM_REPORT_FAILURE:
      return {
        ...state,
        saveCustomReport: {
          ...state.saveCustomReport,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.error_code || 0,
          errorMessage: action.payload.body?.error_message || 'Failed to save custom report',
        },
      };
    case actionConstants.SAVE_CUSTOM_REPORT_CLEAR:
      return {
        ...state,
        saveCustomReport: { ...saveCustomReport },
      };

    // CREATE_SCHEDULED_REPORT
    case actionConstants.CREATE_SCHEDULED_REPORT_REQUEST:
      return {
        ...state,
        createScheduledReport: {
          ...state.createScheduledReport,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };
    case actionConstants.CREATE_SCHEDULED_REPORT_SUCCESS:
      return {
        ...state,
        createScheduledReport: {
          ...state.createScheduledReport,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorMessage: '',
        },
      };
    case actionConstants.CREATE_SCHEDULED_REPORT_FAILURE:
      return {
        ...state,
        createScheduledReport: {
          ...state.createScheduledReport,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.error_code || 0,
          errorMessage: action.payload.body?.error_message || 'Failed to create scheduled report',
        },
      };
    case actionConstants.CREATE_SCHEDULED_REPORT_CLEAR:
      return {
        ...state,
        createScheduledReport: { ...createScheduledReport },
      };

    // PAUSE_SCHEDULED_REPORT
    case actionConstants.PAUSE_SCHEDULED_REPORT_REQUEST:
      return {
        ...state,
        pauseScheduledReport: {
          ...state.pauseScheduledReport,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };
    case actionConstants.PAUSE_SCHEDULED_REPORT_SUCCESS:
      return {
        ...state,
        pauseScheduledReport: {
          ...state.pauseScheduledReport,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorMessage: '',
        },
      };
    case actionConstants.PAUSE_SCHEDULED_REPORT_FAILURE:
      return {
        ...state,
        pauseScheduledReport: {
          ...state.pauseScheduledReport,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.error_code || 0,
          errorMessage: action.payload.body?.error_message || 'Failed to pause scheduled report',
        },
      };
    case actionConstants.PAUSE_SCHEDULED_REPORT_CLEAR:
      return {
        ...state,
        pauseScheduledReport: { ...pauseScheduledReport },
      };

    // RESUME_SCHEDULED_REPORT
    case actionConstants.RESUME_SCHEDULED_REPORT_REQUEST:
      return {
        ...state,
        resumeScheduledReport: {
          ...state.resumeScheduledReport,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };
    case actionConstants.RESUME_SCHEDULED_REPORT_SUCCESS:
      return {
        ...state,
        resumeScheduledReport: {
          ...state.resumeScheduledReport,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorMessage: '',
        },
      };
    case actionConstants.RESUME_SCHEDULED_REPORT_FAILURE:
      return {
        ...state,
        resumeScheduledReport: {
          ...state.resumeScheduledReport,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.error_code || 0,
          errorMessage: action.payload.body?.error_message || 'Failed to resume scheduled report',
        },
      };
    case actionConstants.RESUME_SCHEDULED_REPORT_CLEAR:
      return {
        ...state,
        resumeScheduledReport: { ...resumeScheduledReport },
      };

      // DELETE_SCHEDULED_REPORT
      case actionConstants.DELETE_SCHEDULED_REPORT_REQUEST:
        return {
          ...state,
          deleteScheduledReport: {
            ...state.deleteScheduledReport,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            errorCode: 0,
            errorMessage: '',
          },
        };
      case actionConstants.DELETE_SCHEDULED_REPORT_SUCCESS:
        return {
          ...state,
          deleteScheduledReport: {
            ...state.deleteScheduledReport,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            errorMessage: '',
          },
        };
      case actionConstants.DELETE_SCHEDULED_REPORT_FAILURE:
        return {
          ...state,
          deleteScheduledReport: {
            ...state.deleteScheduledReport,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            errorCode: action.payload.body?.error_code || 0,
            errorMessage: action.payload.body?.error_message || 'Failed to delete scheduled report',
          },
        };
      case actionConstants.DELETE_SCHEDULED_REPORT_CLEAR:
        return {
          ...state,
          deleteScheduledReport: {
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            errorCode: 0,
            data: {},
            errorMessage: '',
          },
        };

            // UPDATE_SCHEDULED_REPORT
      case actionConstants.UPDATE_SCHEDULED_REPORT_REQUEST:
        return {
          ...state,
          updateScheduledReport: {
            ...state.updateScheduledReport,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            errorCode: 0,
            errorMessage: '',
          },
        };
      case actionConstants.UPDATE_SCHEDULED_REPORT_SUCCESS:
        return {
          ...state,
          updateScheduledReport: {
            ...state.updateScheduledReport,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            errorMessage: '',
          },
        };
      case actionConstants.UPDATE_SCHEDULED_REPORT_FAILURE:
        return {
          ...state,
          updateScheduledReport: {
            ...state.updateScheduledReport,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            errorCode: action.payload.body?.error_code || 0,
            errorMessage: action.payload.body?.error_message || 'Failed to update scheduled report',
          },
        };
      case actionConstants.UPDATE_SCHEDULED_REPORT_CLEAR:
        return {
          ...state,
          updateScheduledReport: { ...updateScheduledReport },
        };
    default:
      return state;
  }
  
};

export default reportsReducer;

